/**
 * The possible battery levels
 */
export enum BATTERY_LEVEL {
    UNKNOWN,
    ERROR,
    LOW,
    OK,
    GOOD,
    FULL,
}

/** Ascending bands: a reading below `max` (and at or above the previous band's `max`) takes `level`; at or above the last `max` is FULL. */
export type BatteryLevelThresholds = { max: number; level: BATTERY_LEVEL }[];

/**
 * The voltage levels for 9 volt block devices
 * version: 4.*.*.* and 3.block.*.*.*
 */
export const BLOCK_VOLTAGE_LEVELS: BatteryLevelThresholds = [
    { max: 6, level: BATTERY_LEVEL.ERROR },
    { max: 7.5, level: BATTERY_LEVEL.LOW },
    { max: 8.0, level: BATTERY_LEVEL.OK },
    { max: 9.0, level: BATTERY_LEVEL.GOOD },
    { max: 10.0, level: BATTERY_LEVEL.FULL },
];

/**
 * The voltage levels for micro devices (with 2*AA batteries)
 * version: 3.micro.*.*.*
 *
 * Values here are taken from the AA spec sheet and multiplied by 2 to account for the two batteries
 */
export const SPROUT_VOLTAGE_LEVELS_MICRO: BatteryLevelThresholds = [
    { max: 1.5 * 2, level: BATTERY_LEVEL.ERROR },
    { max: 1.55 * 2, level: BATTERY_LEVEL.LOW },
    { max: 1.6 * 2, level: BATTERY_LEVEL.OK },
    { max: 1.65 * 2, level: BATTERY_LEVEL.GOOD },
    { max: 1.7 * 2, level: BATTERY_LEVEL.FULL },
];

/**
 * The battery percent levels for the Seed device stats, also used by legacy Sensoterra probes
 * version: 1.*.*.*.*
 */
export const SEED_DEVICE_STATS_BATTERY_LEVELS: BatteryLevelThresholds = [
    { max: 1.3, level: BATTERY_LEVEL.ERROR },
    { max: 1.4, level: BATTERY_LEVEL.LOW },
    { max: 1.6, level: BATTERY_LEVEL.OK },
    { max: 1.7, level: BATTERY_LEVEL.FULL },
];

/** Sensoterra probe `batteryIndicator` voltage; below 1 V is not a reading. */
export const SENSOTERRA_PROBE_VOLTAGE_LEVELS: BatteryLevelThresholds = [
    { max: 1, level: BATTERY_LEVEL.UNKNOWN },
    { max: 2.6, level: BATTERY_LEVEL.ERROR },
    { max: 2.7, level: BATTERY_LEVEL.LOW },
    { max: 2.8, level: BATTERY_LEVEL.GOOD },
];

/** ePlant TreeTag `batteryIndicator` voltage. */
export const EPLANT_TREE_TAG_VOLTAGE_LEVELS: BatteryLevelThresholds = [
    { max: 2.6, level: BATTERY_LEVEL.ERROR },
    { max: 2.8, level: BATTERY_LEVEL.LOW },
    { max: 3.2, level: BATTERY_LEVEL.GOOD },
];
